import { Typography } from "@mui/material";


export default function PageTitle({title, autoHide = true, caption}) {
  return (
    <>
      <Typography 
        // display={{xs: 'block', lg: autoHide ? 'none' : 'block'}} 
        className="page-title accent-secondary-dark" 
        variant='h6' 
        component="h6" 
        sx={{fontWeight: 400, }}
        >
        {title}
      </Typography>
      {caption && <Typography variant="caption" color="grey">{caption}</Typography>}
    </>
  )
}
